import React, { ComponentType, FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import { LifecyclePlugin } from '../../../../capacitor_plugins/lifecycle';
import { CAPACITOR_LIFECYCLE_PLUGIN } from '../../../../capacitor_plugins/pluginConstants';
import { selectIsSplashVisible } from './AppSplash';
import { ImmutableMap } from '../../../../common/utils/immutableHelper';

interface DecoratorProps {
    location: Location;
    isSplashVisible?: boolean;
}

export default <P extends DecoratorProps>(DecoratedComponent: ComponentType<P>) => {
    const SplashLoadingStateDecorator: FC<P> = (props) => {
        const isSplashVisible = useSelector((state: ImmutableMap) => selectIsSplashVisible(state, props.location));

        useEffect(() => {
            if (isSplashVisible && Capacitor.isPluginAvailable(CAPACITOR_LIFECYCLE_PLUGIN)) {
                LifecyclePlugin.splashDidLoad();
            }
        }, [isSplashVisible]);

        return <DecoratedComponent {...props} isSplashVisible={isSplashVisible} />;
    };

    return SplashLoadingStateDecorator;
};
